module.exports = __webpack_public_path__ + "play/static/media/arrowleft.a77d593b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrowleft.svg
// module id = 226
// module chunks = 0